import { ISideBar, sidebarItem } from 'app/configs/sidebar.config';
import React, { ReactElement, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './SidebarComponent.scss';

const SidebarComponent = function init(): React.ReactElement {
    const sidebarList: ISideBar[] = sidebarItem;
    const [pathname, setPathname] = useState('/');
    const location = useLocation();

    useEffect(() => {
        setPathname(location.pathname);
    }, [location]);

    function renderSideLink(menu: ISideBar): ReactElement {
        return (
            <div className="menu" key={menu.name}>
                <NavLink
                    to={menu.path}
                    className={() => `nav-link ${pathname.includes(menu.pathname) ? "selected" : ""}`}
                >
                    <div className="content">
                        <img
                            src={pathname.includes(menu.pathname)
                            ? menu.activeImage : menu.image}
                            alt={menu.name}
                        />
                        <p>{menu.name}</p>
                    </div>
                </NavLink>
            </div>
        );
    }

    return (
        <div className="sidebar">
            <div className="sidebar-container">
                {sidebarList.map((menu) => renderSideLink(menu))}
            </div>
        </div>
    );
};

export default SidebarComponent;
